module.exports = __webpack_public_path__ + "img/atl_site.c47de16b.png";